// extracted by mini-css-extract-plugin
export var main = "by_fz";
export var target = "by_fy";